import React from 'react'

import { cn } from '@/lib/utils'

import { StylesProps } from '../page-header.types'
import { HeaderDescription } from '../shared/header-description'
import { HeaderLogo } from '../shared/header-logo'
import { HeaderName } from '../shared/header-name'
import { HeaderSocialIcons } from '../shared/header-social-icons'

export const BigLogoPageHeader = ({
  page,
  forceMobile,
  ...props
}: StylesProps) => {
  return (
    <div className={cn('p-fluid-4', { 'lg:pt-fluid-14': !forceMobile })}>
      <div className="relative text-page-text">
        <div className="relative mb-fluid-8 flex flex-col items-center justify-center space-y-fluid-3">
          <div className="mb-fluid-6 flex">
            <HeaderLogo
              media={page?.logoMedia || page?.bannerMedia}
              {...props}
              className="shadow-page-widget rounded-page-widget"
              sizeClassName="size-fluid-44"
              size={176}
            />
          </div>

          <HeaderName name={page?.name} className="text-center" {...props} />

          <HeaderDescription
            description={page?.description}
            className="text-center"
            {...props}
          />

          <HeaderSocialIcons
            socialIcons={page?.socialIcons}
            className="text-center"
            sizeClassName="size-fluid-7"
            {...props}
          />
        </div>
      </div>
    </div>
  )
}
